import { Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttDialog } from '../../sporttia/all';
import useTpvsService, { getGetTpvQueryKey } from '../../services/TpvsService';
import { PosPaymentParams } from '../../types/payment';
import POSPaymentDialog from './POSPaymentDialog';
import SipayPaymentDialog from './SipayPaymentDialog';

type DataphonePaymentDialogProps = {
    paymentData: PosPaymentParams | null;
    open: boolean;
    onClose: () => void;
    onSuccess?: (ticket?: unknown, returnParams?: unknown) => void;
};

/**
 * Cobro con datáfono conectado (sin Stripe). El banco se lee del TPV: con
 * Sipay la venta va por el API de Sporttia; con el resto, al datáfono
 * Paycomet de la red local, como siempre.
 */
export default function DataphonePaymentDialog({
    paymentData,
    open,
    onClose,
    onSuccess,
}: DataphonePaymentDialogProps) {
    const { t } = useTranslation();
    const tpvsService = useTpvsService();
    const idTpv = paymentData?.idTpv ?? 0;
    const active = open && paymentData !== null;

    const tpvQuery = tpvsService.useGetTpv(idTpv, undefined, {
        queryKey: getGetTpvQueryKey(idTpv),
        enabled: active,
    });

    if (!active) return null;

    if (tpvQuery.isPending) {
        return (
            <SttDialog
                open
                title={t('posPaymentDialog.title')}
                maxWidth="sm"
                onClose={onClose}
                content={
                    <Box className="flex justify-center">
                        <CircularProgress />
                    </Box>
                }
            />
        );
    }

    if (tpvQuery.data?.tpv.tpvConf?.bank === 'SIPAY') {
        return (
            <SipayPaymentDialog
                paymentData={paymentData}
                onClose={onClose}
                onSuccess={onSuccess}
            />
        );
    }

    return (
        <POSPaymentDialog
            open
            paymentData={paymentData}
            onClose={onClose}
            onSuccess={onSuccess}
        />
    );
}
